import ApplicationSummary from "components/ApplicationSummary";
import DocumentFolderInput from "components/DocumentFolderInput";
import { DocumentFolderTypesAndFileExtensions } from "services/types";
import { SectionHeader } from "../layout";
import { ApplicationFormik } from "../types";
import "./styles.scss";

function ApplicationReviewDocumentsSection({
	formik,
	documentFolderTypesData
}: Readonly<
	ApplicationFormik & {
		documentFolderTypesData: DocumentFolderTypesAndFileExtensions;
	}
>): JSX.Element {
	const { values } = formik;
	const { documentFolders } = values;

	return (
		<div className="w-full flex flex-col items-center gap-4 mt-4 text-sm">
			{documentFolderTypesData.documentFolderTypes
				.filter((folderType) => (documentFolders[folderType.id]?.documents.length ?? 0) > 0)
				.map((folderType) => (
					<DocumentFolderInput
						key={folderType.id}
						readonly
						folderName={folderType.documentType.name}
						folderType={folderType.id}
						minDocumentCount={folderType.minAmountDocuments}
						value={documentFolders[folderType.id]}
						fileExtensions={null}
						initiallyExpanded={false}
						shouldValidate={false}
					/>
				))}
		</div>
	);
}

export default function ApplicationReview({
	formik,
	documentFolderTypesData
}: Readonly<
	ApplicationFormik & {
		documentFolderTypesData: DocumentFolderTypesAndFileExtensions | null;
	}
>): JSX.Element {
	return (
		<div className="flex flex-col overflow-y-auto p-8 gap-8 h-full max-w-2xl">
			<div>
				<SectionHeader title="Revise todas as informações" />
				<div className="text-neutral-low-400 text-sm mt-4">
					Confirme os dados da solicitação e clique em continuar para seguir com o envio do formulário.
				</div>
			</div>
			<ApplicationSummary values={formik.values} />
			<ApplicationReviewDocumentsSection formik={formik} documentFolderTypesData={documentFolderTypesData!} />
		</div>
	);
}
